import { createContext, useState } from 'react';
import { Category, CategoriesResponse, CategoryResponse } from '../../models/interfaces';
import topApi from '../../components/api/ToPApi';


type CategoriesContextProps = {
    categories: Category[];
    totalPage: number;
    loadCategories: () => Promise<void>;
    createCategory: (category: Category, onCreated?: (category: Category) => void) => Promise<string>;
    updateCategory: (category: Category) => Promise<string>;
    deleteCategory: (id: number) => Promise<string>;
}


export const CategoriesContext = createContext({} as CategoriesContextProps);

export const CategoriesProvider = ({ children }: any) => {

    const [categories, setCategories] = useState<Category[]>([]);
    const [totalPage, setTotalPage] = useState<number>(0);

    const loadCategories = async () => {
        const resp = await topApi.get<CategoriesResponse>('/category/getCategories');
        if (resp.status == 200) {
            setCategories([...resp.data.categories]);
            setTotalPage(1);
        }
    }

    const createCategory = async (category: Category, onCreated?: (category: Category) => void) => {
        try {
            category.id = undefined;
            const resp = await topApi.post<CategoryResponse>('/category/', { category });
            setCategories([...categories, resp.data.category]);
            onCreated?.(resp.data.category);
            return 'success'

        } catch (e) {
            const error = e.response?.data?.error;
            return error || "Ocurrió un error de comunicación, intente de nuevo.";
        }
    }

    const updateCategory = async (category: Category) => {
        try {
            const resp = await topApi.put<CategoryResponse>(`/category/${category.id}`, { category });

            setCategories(categories.map(cat => {
                return (cat.id === category.id)
                    ? resp.data["category"]
                    : cat;
            }));

            return 'success'

        } catch (e) {
            const error = e.response?.data?.error;
            return error || "Ocurrió un error de comunicación, intente de nuevo.";
        }
    }

    const deleteCategory = async (id: number) => {
        try {
            await topApi.delete<CategoryResponse>(`/category/${id}`);
            setCategories((prevCategories) =>
                prevCategories.filter((category) => category.id! !== id)
            );
            return 'success'
        } catch (e) {
            const error = e.response?.data?.error;
            return error || "Ocurrió un error de comunicación, intente de nuevo.";
        }
    }

    return (
        <CategoriesContext.Provider value={{ categories, totalPage, loadCategories, createCategory, updateCategory, deleteCategory }}>
            {children}
        </CategoriesContext.Provider>
    );
}
